module.exports = __webpack_public_path__ + "images/emoji/arrow_lower_left.b1cc15a50ce954ead584.png";